import { render } from "./Vehiculos.vue?vue&type=template&id=8b216bb6&ts=true"
import script from "./Vehiculos.vue?vue&type=script&lang=ts"
export * from "./Vehiculos.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__